import { render, staticRenderFns } from "./HotCom.vue?vue&type=template&id=4fdc503e&scoped=true&"
import script from "./HotCom.vue?vue&type=script&lang=js&"
export * from "./HotCom.vue?vue&type=script&lang=js&"
import style0 from "./HotCom.vue?vue&type=style&index=0&id=4fdc503e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdc503e",
  null
  
)

export default component.exports